<template>
  <div class = "container">
    <div class = "landing"></div>
    <div class = "overlay"></div>
    <div class = "content">
      <Header color = "white" type="page" />
      <div class = "text">
        <Tcon v-if="!partialSuccess" icon="f-check-circle" class="check-circle"/>
        <Tcon v-else icon="f-exclamation-circle-filled" class="exclamation-circle"/>
        <h1 v-if="messageMap">{{messageMap[lang ? lang.toUpperCase() : 'EN']}}</h1>
        <p v-if="promoURL && countDown > 0" class="redirect"> {{ lang === 'en' ? 'Redirecting to your offer in ' : 'Redireccionando a su oferta en ' }} {{ countDown }}...</p>

        <p v-if="promoURL && countDown <= 0 && lang === 'en'" class="redirect"> If you were not redirected you can click <a :href="promoURL" target="_blank">here</a> to view your offer</p>
        <p v-else-if="promoURL && countDown <= 0 && lang === 'es'" class="redirect"> Si no fue redirigido, puede hacer clic <a :href="promoURL" target="_blank">aquí</a> para ver su oferta</p>

        <p v-if="secondaryMessageMap && secondaryMessageMap.EN && secondaryMessageMap.ES" class="redirect"> {{secondaryMessageMap[lang ? lang.toUpperCase() : 'EN']}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../components/Header'
import Tcon from '../iconography/Tcon'
export default {
  name: 'ExternalCustomerSuccess',
  components: {
    Header,
    Tcon,
  },
  data() {
    return {
      countDown: 5
    }
  },
  props: ['promoURL', 'messageMap', 'secondaryMessageMap', 'partialSuccess', 'lang'],
  mounted() {
    if (this.promoURL) {
      this.countDownTimer()
    }
  },
  methods: {
    countDownTimer () {
      if(this.countDown > 0) {
        setTimeout(() => {
          this.countDown--
          this.countDownTimer()
        }, 1000)
      } else {
        window.open(this.promoURL, "_blank")
      }
    },
  }
}
</script>

<style scoped>

.check-circle {
  fill: rgb(255, 255, 255);
}
.check-circle, .exclamation-circle {
  height: 108px;
  padding-bottom: 2.5vh;
}

.exclamation-circle {
  fill: white;
}
.landing {
  background: url('../assets/landing.jpg') no-repeat center center fixed;
  width: 100%;
  background-size: cover;
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: -10;
  filter: blur(2px);
}

.overlay {
  width: 100%;
  height: 100%;
  background-color: #000;
  position: fixed;
  opacity: 0.7;
}

.container {
  width: 100%;
}

.content .text {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: white;
  min-height: stretch;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 0;
  padding: 2.5vh 5vw;
}

h1 {
  font-size: 3rem;
  font-weight: 300;
  margin: 0;
  padding: 0 5rem;
  text-align: center;
}

p {
  font-size: 1.25rem;
  padding-top: 2rem;
}

button {
  background-color: #0057B8; /* Cobalt 600 */
  height: 3rem;
  font-size: 1.3rem;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  color: white;
  width: 10rem;
  border-radius: 0.3rem;
  margin: 3rem auto;
  border: none
}

.redirect {
  text-align: center;
}
</style>